module.exports = __webpack_public_path__ + "static/media/010.43653e78.jpg";